import {z} from "zod/v4-mini"
import {isMattressCurveLikeNode, isMattressReferenceFrameLikeNode, isMattressComponentGraphLikeNode} from "#mattress/role-markers"
import type {MattressCurveLikeNode, MattressReferenceFrameLikeNode, MattressComponentGraphLikeNode} from "#mattress/role-markers"

export const mattressCurveLike = z.custom<MattressCurveLikeNode>(isMattressCurveLikeNode)
export const mattressReferenceFrameLike = z.custom<MattressReferenceFrameLikeNode>(isMattressReferenceFrameLikeNode)
export const mattressComponentGraphLike = z.custom<MattressComponentGraphLikeNode>(isMattressComponentGraphLikeNode)

export const mattressGlobalReferenceFrame = z.literal("global")
export const MATTRESS_BASE_MESH = "MATTRESS_BASE_MESH"
export const mattressBaseMesh = z.literal(MATTRESS_BASE_MESH)
export type MattressBaseMesh = typeof MATTRESS_BASE_MESH

export const mattressReferenceFrameTypeOptions = ["xAxisRing", "yAxisRing", "zAxisRing"] as const
export type MattressReferenceFrameType = (typeof mattressReferenceFrameTypeOptions)[number]
export const mattressReferenceFrameType: z.ZodMiniType<MattressReferenceFrameType, MattressReferenceFrameType> = z.enum(mattressReferenceFrameTypeOptions)
